import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import Select from 'react-select';
import ToggleSwitch from '@trendmicro/react-toggle-switch';

import TextareaCounter from '../../FormComponents/TextareaCounter';

import { TextField } from '../../common';

const bookBefore = [
  {
    label: '10 minutes',
    value: 'PT10M',
  },
  {
    label: '30 minutes',
    value: 'PT30M',
  },
  {
    label: '1 hour',
    value: 'PT1H',
  },
  {
    label: '2 hours',
    value: 'PT2H',
  },
  {
    label: '3 hours',
    value: 'PT3H',
  },
  {
    label: '6 hours',
    value: 'PT6H',
  },
  {
    label: '24 hours',
    value: 'PT24H',
  },
  {
    label: '48 hours',
    value: 'PT48H',
  },
  {
    label: '72 hours',
    value: 'PT72H',
  },
];

const cancellationDuration = [
  {
    label: '1 hour',
    value: 'PT1H',
  },
  {
    label: '2 hours',
    value: 'PT2H',
  },
  {
    label: '3 hours',
    value: 'PT3H',
  },
  {
    label: '6 hours',
    value: 'PT6H',
  },
  {
    label: '8 hours',
    value: 'PT8H',
  },
  {
    label: '12 hours',
    value: 'PT12H',
  },
  {
    label: '18 hours',
    value: 'PT18H',
  },
  {
    label: '24 hours',
    value: 'PT24H',
  },
  {
    label: '48 hours',
    value: 'PT48H',
  },
  {
    label: '72 hours',
    value: 'PT72H',
  },
  {
    label: '96 hours',
    value: 'PT96H',
  },
  {
    label: 'ALL',
    value: 'PT48000H',
  },
  {
    label: 'NONE',
    value: 'PT0S',
  },
];

export default function Bookings({
  values,
  errors,
  onChange,
  setRef,
  disabled,
  scheduling,
  auth,
  softwares,
}) {
  const onBookBeforeChange = (item) => {
    onChange({
      target: {
        name: 'min_time_to_booking',
        value: item.value,
      },
    });
  };

  const onCancellationDurationChange = (item) => {
    onChange({
      target: {
        name: 'cancellation_duration',
        value: item.value,
      },
    });
  };

  const onRescheduleAppointment24Change = () => {
    onChange({
      target: {
        type: 'checkbox',
        name: 'reschedule_appt_within_24hrs',
        checked: !values.reschedule_appt_within_24hrs,
      },
    });
  };

  const onCancelAppointmentDurationChange = () => {
    onChange({
      target: {
        type: 'checkbox',
        name: 'cancel_appt_within_duration',
        checked: !values.cancel_appt_within_duration,
      },
    });
  };

  const onSharePricingChange = () => {
    onChange({
      target: {
        type: 'checkbox',
        name: 'can_share_pricing_with_clients',
        checked: !values.can_share_pricing_with_clients,
      },
    });
  };

  const onWalkInAppointmentsChange = () => {
    onChange({
      target: {
        type: 'checkbox',
        name: 'appointments_walk_in',
        checked: !values.appointments_walk_in,
      },
    });
  };
  const onOnlineRescheduleBooking = () => {
    onChange({
      target: {
        type: 'checkbox',
        name: 'can_reschedule_booking_online',
        checked: !values.can_reschedule_booking_online,
      },
    });
  };

  const onOnlineCancelBooking = () => {
    onChange({
      target: {
        type: 'checkbox',
        name: 'can_cancel_booking_online',
        checked: !values.can_cancel_booking_online,
      },
    });
  };

  const onChangeAvgBookingValue = (event) => {
    onChange({
      target: {
        type: 'text',
        name: 'average_booking_value',
        value: event.target.value.replace(/[^\w\s]/gi, ''),
      },
    });
  };

  const customStyles = {
    menu: (provided, state) => ({
      ...provided,
      zIndex: 3,
    }),
  };
  const { properties } = scheduling;
  const bzsW =
    auth.booking_software && auth.booking_software !== 'undefined'
      ? auth.booking_software
      : softwares.selectedSoftware;
  return (
    <div className="bookings sceduling">
      {properties?.online_booking_link && (
        <div className="bookings__row">
          <p className="bookings__row__label">
            {properties?.online_booking_link.description ||
              'Link where guests can book an appointment online'}
          </p>
          <div className="bookings__row__input">
            <input
              type="text"
              placeholder="URL"
              name="online_booking_link"
              value={values.online_booking_link}
              onChange={onChange}
              className={classnames({
                'has-error': errors.online_booking_link,
              })}
              ref={setRef}
              disabled={disabled}
            />
            <span className="message--small message--error">
              {errors.online_booking_link && errors.online_booking_link.message}
            </span>
          </div>
        </div>
      )}

      {properties?.average_booking_value && (
        <div className="bookings__row">
          <p className="bookings__row__label">
            {properties?.average_booking_value.description ||
              'Average appointment booking value'}
          </p>
          <div className="bookings__row__input">
            <div className="currency">
              <span>$</span>
              <input
                type="text"
                placeholder="Average Booking Value"
                name="average_booking_value"
                value={values.average_booking_value}
                onChange={onChangeAvgBookingValue}
                className={classnames({
                  'has-error': errors.average_booking_value,
                })}
                ref={setRef}
                disabled={disabled}
              />
            </div>
            <span className="message--small message--error">
              {errors.average_booking_value &&
                errors.average_booking_value.message}
            </span>
          </div>
        </div>
      )}

      {properties?.can_reschedule_booking_online && (
        <div className="special-row">
          <p className="special-row__label">
            {properties?.can_reschedule_booking_online.description ||
              'Can guests reschedule an appointment online?'}
          </p>
          <div className="special-row__input">
            <ToggleSwitch
              checked={!!values.can_reschedule_booking_online}
              name="can_reschedule_booking_online"
              onChange={onOnlineRescheduleBooking}
              disabled={disabled}
            />
          </div>
        </div>
      )}

      {properties?.can_cancel_booking_online && (
        <div className="special-row">
          <p className="special-row__label">
            {properties?.can_cancel_booking_online.description ||
              'Can guests cancel an appointment online?'}
          </p>
          <div className="special-row__input">
            <ToggleSwitch
              checked={!!values.can_cancel_booking_online}
              name="can_cancel_booking_online"
              onChange={onOnlineCancelBooking}
              disabled={disabled}
            />
          </div>
        </div>
      )}

      {properties?.min_time_to_booking && (
        <div className="bookings__row">
          <p className="bookings__row__label">
            {properties?.min_time_to_booking?.description ||
              `When TrueLark books appointments for you, how close to the start of
          the session can we book?`}
          </p>
          <div className="bookings__row__input">
            <Select
              value={bookBefore.filter(
                (option) => option.value === values.min_time_to_booking,
              )}
              getOptionLabel={(option) => option.label}
              getOptionValue={(option) => option.value}
              options={bookBefore}
              styles={customStyles}
              onChange={onBookBeforeChange}
              disabled={disabled}
            />
          </div>
        </div>
      )}

      {/* <div className="bookings__row toggle-row">
        <p className="bookings__row__label">
          Can TrueLark reschedule appointments within 24 hours of the start of the session?
        </p>
        <div className="bookings__row__input">
        <div className="bookingsonBookBeforeChange__row__input">
          <ToggleSwitch
            checked={!!values.reschedule_appt_within_24hrs}
            name="reschedule_appt_within_24hrs"
            onChange={onRescheduleAppointment24Change}
            disabled={disabled}
          />
        </div>
        </div>
      </div> */}

      {/* <div className="bookings__row">
        <p className="bookings__row__label">
          What are your reschedule charges?
        </p>
        <div className="bookings__row__input">
          <input
            type="text"
            placeholder="e.g. 50%, $25"
            name="reschedule_charges"
            value={values.reschedule_charges}
            onChange={onChange}
            className={classnames({ 'has-error': errors.reschedule_charges })}
            ref={setRef}
            disabled={disabled}
          />
          <span className="message--small message--error">
            {errors.reschedule_charges && errors.reschedule_charges.message}
          </span>
        </div>
      </div> */}
      {bzsW == 'SCIBLER' ? (
        <>
          {properties?.cancellation_policy && (
            <div className="bookings__row">
              <p className="bookings__row__label">
                {properties?.cancellation_policy?.description ||
                  'What is your cancellation policy?'}
              </p>
              <div className="bookings__row__input">
                <TextareaCounter
                  rows="3"
                  name="cancellation_policy"
                  value={values.cancellation_policy}
                  onChange={onChange}
                  className={classnames({
                    'has-error': errors.cancellation_policy,
                  })}
                  ref={setRef}
                  maxLength={160}
                  disabled={disabled}
                />
                <span className="message--small message--error">
                  {errors.cancellation_policy &&
                    errors.cancellation_policy.message}
                </span>
              </div>
            </div>
          )}{' '}
        </>
      ) : (
        <>
          {properties.cancellation_duration && (
          <div className="bookings__row">
            <p className="bookings__row__label">
              {properties.cancellation_duration?.description ||
                'Select the late cancellation window'}
            </p>
            <div className="bookings__row__input">
              <Select
                value={cancellationDuration.filter(
                  (option) => option.value === values.cancellation_duration,
                )}
                getOptionLabel={(option) => option.label}
                getOptionValue={(option) => option.value}
                options={cancellationDuration}
                styles={customStyles}
                onChange={onCancellationDurationChange}
                disabled={disabled}
              />
            </div>
          </div>
          )}
          {properties?.cancel_appt_within_duration && (
            <div className="bookings__row toggle-row">
              <p className="bookings__row__label">
                {properties?.cancel_appt_within_duration?.description ||
                  'Can TrueLark cancel appointments within your late cancellation window?'}
              </p>
              <div className="bookings__row__input">
                <ToggleSwitch
                  checked={!!values.cancel_appt_within_duration}
                  name="cancel_appt_within_duration"
                  onChange={onCancelAppointmentDurationChange}
                  disabled={disabled}
                />
              </div>
            </div>
          )}
          {/* <div className="bookings__row">
            <p className="bookings__row__label">
              What are your cancellation charges?
            </p>
            <div className="bookings__row__input">
              <input
                type="text"
                placeholder="e.g. 50%, $25"
                name="cancellation_charges"
                value={values.cancellation_charges}
                onChange={onChange}
                className={classnames({ 'has-error': errors.cancellation_charges })}
                ref={setRef}
                disabled={disabled}
              />
              <span className="message--small message--error">
                {errors.cancellation_charges && errors.cancellation_charges.message}
              </span>
            </div>
          </div> */}
          {properties?.cancellation_policy && (
          <div className="bookings__row">
            <p className="bookings__row__label">
              What is your cancellation policy?
            </p>
            <div className="bookings__row__input">
              <TextareaCounter
                rows="3"
                name="cancellation_policy"
                value={values.cancellation_policy}
                onChange={onChange}
                className={classnames({
                  'has-error': errors.cancellation_policy,
                })}
                ref={setRef}
                maxLength={160}
                disabled={disabled}
              />
              <span className="message--small message--error">
                {errors.cancellation_policy &&
                  errors.cancellation_policy.message}
              </span>
            </div>
          </div>
          )}{' '}
        </>
      )}
      {/* <div className="bookings__row">
        <p className="bookings__row__label">
          Can TrueLark share pricing information with clients?
        </p>
        <div className="bookings__row__input">
          <ToggleSwitch
            checked={!!values.can_share_pricing_with_clients}
            name="can_share_pricing_with_clients"
            onChange={onSharePricingChange}
            disabled={disabled}
          />
        </div>
      </div> */}
      {properties?.appointments_walk_in && (
        <div className="bookings__row toggle-row">
          <p className="bookings__row__label">
            {properties?.appointments_walk_in?.description ||
              'Do you take walk-in appointments?'}
          </p>
          <div className="bookings__row__input">
            <ToggleSwitch
              checked={!!values.appointments_walk_in}
              name="appointments_walk_in"
              onChange={onWalkInAppointmentsChange}
              disabled={disabled}
            />
          </div>
        </div>
      )}

      {properties?.post_booking_instructions && (
        <div className="bookings__row">
          <p className="bookings__row__label">
            {properties?.post_booking_instructions?.description ||
              `Are there any specific post-booking messages you would like TrueLark
          to share? If so, please specify here.`}
          </p>
          <div className="bookings__row__input">
            <TextareaCounter
              rows="3"
              placeholder="Please arrive 5 minutes before your appointment if you are a new Patient"
              name="post_booking_instructions"
              value={values.post_booking_instructions}
              onChange={onChange}
              maxLength={160}
              disabled={disabled}
            />
          </div>
        </div>
      )}
      {properties?.new_patient_form_link && (
        <div>
          <p className="bookings__row__label">
            {properties?.new_patient_form_link?.description ||
              'New Patient form link'}
          </p>
          <div className="bookings__row__input">
            <input
              type="text"
              name="new_patient_form_link"
              value={values.new_patient_form_link}
              onChange={onChange}
              className={classnames({
                'has-error': errors.new_patient_form_link,
              })}
              ref={setRef}
              disabled={disabled}
            />
            <span className="message--small message--error">
              {errors.new_patient_form_link &&
                errors.new_patient_form_link.message}
            </span>
          </div>
        </div>
      )}
      {/* <div className="bookings__row">
        <p className="bookings__row__label">
          Patient form link?
        </p>
      </div> */}
      {/* <div
        className="bookings__row"
        style={{ textAlign: 'right' }}
      >
        <div className="bookings__row__input">
          <TextField
            style={{ width: '100%' }}
            label=""
            name="new_patient_form_link"
            value={values.new_patient_form_link}
            onChange={onChange}
            error={errors.new_patient_form_link}
          />
        </div>
      </div> */}
    </div>
  );
}

Bookings.defaultProps = {
  onChange: () => {},
  setRef: () => {},
  values: {},
  errors: {},
  disabled: false,
};

Bookings.propTypes = {
  onChange: PropTypes.func,
  setRef: PropTypes.func,
  values: PropTypes.shape(),
  errors: PropTypes.shape(),
  disabled: PropTypes.bool,
};
